import { XMarkIcon } from "@heroicons/react/24/outline";
import DialogStopBotConvert from "./DialogStopBotConvert";
import Dialog from ".";
import { useEffect, useState } from "react";
import { useBot } from "../../context/botContext";
import { baseAxios } from "../../apis";
import { IconLoading } from "../../assets/icons";
import { formatCrypto, getAssetName } from "../../utils";
import SkeletonCard from "../skeletons/SkeletonCard";
import Drawer from "../commons/Drawer";
import { CheckIcon, InformationCircleIcon } from "@heroicons/react/16/solid";

const DialogStopBot = ({ open, onClose, handleKeepBalance, botDetail }) => {
  const {
    loadingStopStartBot,
    setOpenDialogBot,
    loadingConvertData: loading,
    convertData,
  } = useBot();
  const [selected, setSelected] = useState("convert");

  useEffect(() => {
    if (!open) {
      setSelected("convert");
    }
  }, [open]);

  return (
    <Drawer
      open={open}
      onClose={() => {
        if (loadingStopStartBot) return;
        onClose();
      }}
      width="550px"
    >
      <div className="h-full flex flex-col justify-between ">
        {/*  */}
        <div>
          <div className="flex items-center justify-center w-full relative">
            <h2 className="text-xl font-bold">Stop BOT</h2>
            <button
              className="bg-transparent hover:bg-transparent text-black absolute right-0"
              onClick={onClose}
            >
              <XMarkIcon className="w-[18px] h-[18px]" />
            </button>
          </div>
          <div className="mt-5">
            <div className="grid grid-cols-2  mb-3">
              <span>Select Option to Stop BOT</span>
            </div>

            <div className="space-y-3 mb-3">
              {[
                {
                  key: "convert",
                  name: `Convert Balance To ${
                    botDetail?.coin_name?.split("/")[1] || "USDT"
                  } `,
                  description: (
                    <ul className="pl-6 list-disc">
                      <li>Stop Bot’s buy / sell order</li>
                      <li>
                        Convert {getAssetName(convertData?.symbol)} balance
                        to&nbsp;
                        {botDetail?.coin_name?.split("/")[1] || "USDT"} by
                        placing sell order (market or limit price)
                      </li>
                    </ul>
                  ),
                },
                {
                  key: "keep",
                  name: "Keep Balance As-Is",
                  description: (
                    <ul className="pl-6 list-disc">
                      <li>Stop Bot’s buy / sell order</li>
                      <li>
                        Keep balance as Coin and{" "}
                        {botDetail?.coin_name?.split("/")[1] || "USDT"}
                      </li>
                    </ul>
                  ),
                },
              ].map((option) => (
                <div
                  key={option.key}
                  className={`flex gap-2 bg-[#F2F4F8] p-4 px-5 rounded-[10px] cursor-pointer transition border-2 ${
                    selected === option.key
                      ? "border-[#007A78] bg-[#007A78]/10"
                      : "border-transparent"
                  }`}
                  onClick={() => {
                    if (loadingStopStartBot) return;
                    setSelected(option.key);
                  }}
                >
                  <div
                    className={`w-[18px] h-[18px] rounded-full border-2 mt-1 ${
                      selected === option.key
                        ? "border-[#007A78]"
                        : "border-black"
                    } relative`}
                  >
                    {selected === option.key && (
                      <div className="absolute w-full h-full bg-[#007A78] rounded-full flex justify-center items-center text-white">
                        <CheckIcon className="w-[12px] h-[12px]" />
                      </div>
                    )}
                  </div>

                  <div>
                    <h4 className="text-base font-bold m-0">{option.name}</h4>
                    <div className="text-sm text-[#21272A] leading-[1.4] mt-1">
                      {option.description}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {/*  */}
            {selected === "keep" && (
              <div className="bg-[rgba(255,204,0,0.15)] gap-3 p-3 rounded-xl border border-[#FFCC00] flex items-center">
                <InformationCircleIcon className="w-full max-w-[16px] h-[16px] text-[#8F7303]" />
                <span className=" text-sm">
                  Selecting this setting will stop the bot immediately after you
                  press “Confirm” button
                </span>
              </div>
            )}
          </div>
        </div>

        <button
          className="w-full relative overflow-hidden !py-3 !font-bold !text-lg !bg-[#007A78]"
          disabled={loadingStopStartBot}
          onClick={() => {
            if (loadingStopStartBot) return;
            if (selected === "convert") {
              setOpenDialogBot("convert");
              return;
            } else handleKeepBalance();
            // onClose();
          }}
        >
          {loadingStopStartBot ? (
            <div className="animate-spin w-fit flex justify-center items-center mx-auto">
              <IconLoading className="w-[24px] h-[24px]" />
            </div>
          ) : (
            "Confirm"
          )}
        </button>
      </div>
    </Drawer>
  );
};

export default DialogStopBot;
